// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"5445ba9e","194":"5ec4067b","315":"26718976","337":"1f4c67bd","543":"95b2eb37","580":"b2172e6d","584":"fd952cce","679":"b9bf9dca","709":"009b3ba2","787":"7a40e3b2","926":"01e70394"}[chunkId] + ".chunk.js";
};